import * as React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { IconSessionPlan } from "./IconSessionPlan";
import { useSDK } from "../shared/useSDK";
import {
  Breadcrumb,
  BreadcrumbAligner,
  BreadcrumbLink,
} from "./lib/Breadcrumb";

const listLink = {
  to: "/session-plans",
  text: "Session Plans",
  icon: <IconSessionPlan />,
};

export function BreadcrumbSessionPlan() {
  const params = useParams<{ uuid?: string }>();
  return (
    <BreadcrumbAligner>
      <Breadcrumb>
        <BreadcrumbLink to={listLink.to}>
          {listLink.icon}
          <span>{listLink.text}</span>
        </BreadcrumbLink>
        {params.uuid ? <BreadcrumbItem /> : null}
      </Breadcrumb>
    </BreadcrumbAligner>
  );
}

function BreadcrumbItem() {
  const params = useParams<{ uuid: string }>();
  const { sdk } = useSDK();
  const result = useQuery(["sessionPlan", params.uuid], (key, uuid: string) =>
    sdk.getSessionPlan({ sessionPlanUuid: uuid })
  );
  const to = `/session-plans/${params.uuid}`;
  const fallbackText = "Session Plan";
  if (result.status === "loading") {
    return null;
  }
  if (result.status === "error" || result.data === undefined) {
    return <BreadcrumbLink to={to}>{fallbackText}</BreadcrumbLink>;
  }
  return <BreadcrumbLink to={to}>{result.data.data.name}</BreadcrumbLink>;
}
